import { render, staticRenderFns } from "./ReplacementNotification.vue?vue&type=template&id=d6fa2052&scoped=true&"
import script from "./ReplacementNotification.vue?vue&type=script&lang=js&"
export * from "./ReplacementNotification.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementNotification.vue?vue&type=style&index=0&id=d6fa2052&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fa2052",
  null
  
)

/* custom blocks */
import block0 from "./ReplacementNotification.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6fa2052')) {
      api.createRecord('d6fa2052', component.options)
    } else {
      api.reload('d6fa2052', component.options)
    }
    module.hot.accept("./ReplacementNotification.vue?vue&type=template&id=d6fa2052&scoped=true&", function () {
      api.rerender('d6fa2052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/FlyCountView/ReplacementNotification.vue"
export default component.exports